import React, { useState, useEffect } from "react";
import {
  collection,
  doc,
  addDoc,
  getDoc,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase"; // Import your Firebase configuration
import { FaArtstation } from "react-icons/fa";
import { FaHeart } from "react-icons/fa";

const StarRating = ({ artist, user }) => {
  const [rating, setRating] = useState(null);

  useEffect(() => {
    const fetchRating = async () => {
      try {
        const artistRef = doc(db, "artists", artist.id);
        const userRatingRef = doc(artistRef, "ratings", user.uid);
        const userRatingDoc = await getDoc(userRatingRef);

        if (userRatingDoc.exists()) {
          // User has already rated this artist, get their rating
          const userRating = userRatingDoc.data().rating;
          setRating(userRating);
        } else {
          // User has not rated this artist yet
          setRating(null);
        }
      } catch (error) {
        console.error("Error fetching rating:", error);
      }
    };

    fetchRating();
  }, [artist.id, user.uid]);

  const handleRatingClick = async (newRating) => {
    try {
      const artistRef = doc(db, "artists", artist.id);
      const userRatingRef = doc(artistRef, "ratings", user.uid);
      console.log("dispslayName:", user.displayName);

      // Update the user's rating
      await setDoc(userRatingRef, {
        userId: user.uid,
        rating: newRating,
        displayName: user.displayName,
      });

      // Calculate the total rating for the artist
      const artistRatingRef = doc(artistRef, "ratings", "artist"); // Reference to the artist's "ratings/artist" document
      const artistRatingDoc = await getDoc(artistRatingRef);

      if (artistRatingDoc.exists()) {
        // Retrieve the current total rating
        const currentTotalRating = artistRatingDoc.data().totalRating || 0;

        // Calculate the new total rating
        const newTotalRating = currentTotalRating - (rating || 0) + newRating;

        // Update the total rating in the "ratings/artist" document
        await setDoc(artistRatingRef, { totalRating: newTotalRating });
      }

      setRating(newRating);
    } catch (error) {
      console.error("Error updating rating:", error);
    }
  };

  const renderStars = () => {
    const stars = [];
    for (let i = 1; i <= 10; i++) {
      const goldStar = i <= (rating || 0);
      stars.push(
        <span
          key={i}
          className={`star ${goldStar ? "gold" : ""}`}
          onClick={() => handleRatingClick(i)}
          style={{ cursor: "pointer" }}>
          <FaHeart />
        </span>
      );
    }
    return stars;
  };

  return (
    <div className='star-rating bio-questions-box grad-bg pl-5 pr-5'>
      <div>
        <p className='img-title'>
          Cast Your Vote Here for &nbsp;
          <strong>
            {artist.first_name} {artist.last_name}
          </strong>
          <br></br>
          Your Rating: {rating === null ? "Not Rated" : rating}{" "}
        </p>
      </div>
      <div className='stars-container'>{renderStars()}</div>
    </div>
  );
};

export default StarRating;
